import { RefCallback, useCallback, useRef, useState } from 'react'

export interface ElementSize {
  width: number
  height: number
}

/* Callback ref, not an effect: dialog content mounts long after the owning
   component, so a mount-time effect would observe nothing and stay at 0. */
export const useElementSize = (): [
  RefCallback<HTMLDivElement>,
  ElementSize,
] => {
  const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 })
  const observerRef = useRef<ResizeObserver | null>(null)
  const refCallback = useCallback((node: HTMLDivElement | null) => {
    observerRef.current?.disconnect()
    observerRef.current = null
    if (!node) return
    const observer = new ResizeObserver((entries) => {
      const rect = entries[0]?.contentRect
      setSize({ width: rect?.width ?? 0, height: rect?.height ?? 0 })
    })
    observer.observe(node)
    observerRef.current = observer
  }, [])
  return [refCallback, size]
}
